import type { AppSettings } from '@/lib/app-settings';
import { resolveDefaultDisplayName } from './preferences';

/**
 * Returns a copy of `settings` with a display name filled in: any name the user
 * already chose is kept, otherwise one is derived from their account name/email
 * via {@link resolveDefaultDisplayName}. Shared by the initial hydration of
 * stored settings and the "Reset" action so both stay in lockstep. Pure.
 */
export function resolvePreferencesDisplayName(
  settings: AppSettings,
  name: string,
  email: string,
): AppSettings {
  return {
    ...settings,
    displayName: settings.displayName || resolveDefaultDisplayName(name, email),
  };
}
